import { render } from "./sync-categories.vue?vue&type=template&id=e1078a2c"
import script from "./sync-categories.vue?vue&type=script&setup=true&lang=js"
export * from "./sync-categories.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/common/sync-categories.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1078a2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1078a2c', __exports__)) {
    console.log('reload')
    api.reload('e1078a2c', __exports__)
  }
  
  module.hot.accept("./sync-categories.vue?vue&type=template&id=e1078a2c", () => {
    console.log('re-render')
    api.rerender('e1078a2c', render)
  })

}


export default __exports__